export default __webpack_public_path__ + "static/chantries-logo-5560ac4ea28cf30e59af4379d37b75f2.png";